import { render } from "./BIM_LibraryMarketView.vue?vue&type=template&id=15d0bfb2"
import script from "./BIM_LibraryMarketView.vue?vue&type=script&lang=js"
export * from "./BIM_LibraryMarketView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__